import React from "react";
import { getProvidePostionFilter } from "../../lib/common-service";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

import {
  GET_TIME_PERIOD_DATA,
  GET_PROVIDER_DASHBOARD_CARD_DATA,
  GET_FILTER_QUERY,
  GET_PROVIDER_STATUS_AND_PLAN_DATA,
  GET_POSITION_TYPE_DATA,
  GET_SPECIALITY_GROUP_POSITION_DATA,
  GET_PROVIDER_STATUS_AND_PLAN_DATA_BY_SPECIALITY,
  GET_PROVIDER_CHART_STATUS_SUMMARY,
  GET_PROVIDER_BASE_TABLE,
  GET_PROVIDER_CHART_RETENTION,
  GET_LANDING_DASHBOARD_DATA,
  GET_PROVIDER_CHART_ATTRITION,
  GET_PROVIDER_CHART_AGE_EXPERIENCE,
  GET_PROVIDER_TURNOVER_CHART,
  UPDATE_DASHBOARD_CHART_LAYOUT,
  GET_PROVIDER_CHART_YOE_COMBINE,
  GET_PROVIDER_CHART_AR,
} from "../../api-setup/api-endpoints";
import { POSTAPI, errStatusHandler, generateHeader } from "../../api-setup/api-helper";
import { getTenantCookieData, getUserCredential } from "../../lib/cookies";
import { setNewMessage } from "../../redux/actions/setting-actions";
import { GridColumnDataMapper } from "../../utils/utils";
import { CHART_COLOR_PALETTE, PROCARE_COLORS } from "src/constants/constants";

export default function useProviderDashboardData() {
  const cookiesData = getUserCredential();
  const dispatch = useDispatch();
  const history = useHistory();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };

  // Specialty
  const [specialtyDataList, setSpecialtyDataList] = React.useState([]);
  const [specialtyDataFields, setSpecialtyDataFields] = React.useState({
    specialtyDataValue: [],
    specialtyData: [],
    isSpecialtyDataLoading: true,
    search: "",
    filterValue: "",
  });

  // Group
  const [groupDataList, setGroupDataList] = React.useState([]);
  const [groupDataFields, setGroupDataFields] = React.useState({
    groupDataValue: [],
    groupData: [],
    isGroupDataLoading: true,
    search: "",
    filterValue: "",
  });

  // Position
  const [positionDataList, setPositionDataList] = React.useState([]);
  const [positionDataFields, setPositionDataFields] = React.useState({
    positionDataValue: [],
    positionData: [],
    isPositionDataLoading: true,
    search: "",
    filterValue: "",
  });

  // Employee
  const [employeeDataList, setEmployeeDataList] = React.useState([]);
  const [employeeDataFields, setEmployeeDataFields] = React.useState({
    employeeDataValue: [],
    employeeData: [],
    isEmployeeDataLoading: true,
    search: "",
    filterValue: "",
  });

  // NPI
  const [npiDataList, setNpiDataList] = React.useState([]);
  const [npiDataFields, setNpiDataFields] = React.useState({
    npiDataValue: [],
    npiData: [],
    isNpiDataLoading: true,
    search: "",
    filterValue: "",
  });

  const [originalTimePeriodData, setOriginalTimePeriodData] = React.useState([]);
  const [timePeriodData, setTimePeriodData] = React.useState({
    timePeriodValue: {
      in_time_period: "",
    },
    timePeriodDataValue: [],
    istimePeriodDataLoading: true,
  });

  // Loading states
  const [initialLoading, setLoadingState] = React.useState(false);
  const [searchListLoading, setSearchListLoading] = React.useState(false);
  const [isAPICalling, setAPICallingState] = React.useState(false);
  const [isProviderStatusAPICalling, setIsProviderStatusAPICalling] = React.useState(false);
  const [isPositionDataLoading, setIsPositionDataLoading] = React.useState(true);
  const [isProviderStatusAndPlanDataLoading, setIsProviderStatusAndPlanDataLoading] = React.useState(true);
  const [isSpecialtyPositionDataLoading, setIsSpecialtyPositionDataLoading] = React.useState(true);

  // Data states
  const [providerCardData, setProviderCardData] = React.useState([]);
  const [providerPlanStatusData, setProviderPlanStatusData] = React.useState([]);
  const [specialtyPositionData, setSpecialtyPositionData] = React.useState([]);
  const [coloumnData, setColoumnData] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [noDataFound, setNoDataFound] = React.useState(false);

  // Chart states
  const [categories, setCategories] = React.useState([]);
  const [series, setSeries] = React.useState([]);
  const [providerTypeSeries, setProviderTypeSeries] = React.useState([]);
  const [providerTypeCategories, setProviderTypeCategories] = React.useState([]);
  const [positionTypeCategories, setPositionTypeCategories] = React.useState([]);
  const [providerTypeColors, setProviderTypeColors] = React.useState({});
  const [valueAxisMax, setValueAxisMax] = React.useState(0);
  const [valueAxisMajorUnit, setValueAxisMajorUnit] = React.useState(5);
  const [providerValueAxisMax, setProviderValueAxisMax] = React.useState(0);
  const [providerValueAxisMajorUnit, setProviderValueAxisMajorUnit] = React.useState(5);

  // Group Specialty Position states
  const [groupSpecialtyPositionData, setGroupSpecialtyPositionData] = React.useState([]);
  const [groupPositionTypeSeries, setGroupPositionTypeSeries] = React.useState([]);
  const [groupPositionTypeCategories, setGroupPositionTypeCategories] = React.useState([]);
  const [groupProviderTypeColors, setGroupProviderTypeColors] = React.useState({});
  const [isGroupSpecialtyPositionDataLoading, setIsGroupSpecialtyPositionDataLoading] = React.useState(true);
  const [groupNoDataFound, setGroupNoDataFound] = React.useState(false);

  // Specialty Position states
  const [specialtyPositionTypeSeries, setSpecialtyPositionTypeSeries] = React.useState([]);
  const [specialtyPositionTypeCategories, setSpecialtyPositionTypeCategories] = React.useState([]);
  const [specialtyProviderTypeColors, setSpecialtyProviderTypeColors] = React.useState({});
  const [specialtyNoDataFound, setSpecialtyNoDataFound] = React.useState(false);
  const [speclityCategories, setspeclityCategories] = React.useState([]);
  const [speclitySeries, setspeclitySeries] = React.useState([]);
  const [speclityValueAxisMax, setspeclityValueAxisMax] = React.useState(0);
  const [speclityValueAxisMajorUnit, setspeclityValueAxisMajorUnit] = React.useState(5);
  const [isspeclityProviderStatusAndPlanDataLoading, setisspeclityProviderStatusAndPlanDataLoading] =
    React.useState(true);
  const [speclityAPICallingState, setspeclityAPICallingState] = React.useState(false);
  const [speclityLoadingState, setspeclityLoadingState] = React.useState(false);
  const [speclityNoDataFound, setspeclityNoDataFound] = React.useState(false);
  const [ProviderspeclityPlanStatusData, setProviderspeclityPlanStatusData] = React.useState([]);

  const [providerSummaryData, setProviderSummaryData] = React.useState([]);
  const [providerSummaryCategories, setProviderSummaryCategories] = React.useState([]);
  const [providerSummaryLoading, setProviderSummaryLoading] = React.useState(true);
  const [providerSummaryValueAxisMax, setProviderSummaryValueAxisMax] = React.useState(0);
  const [providerSummaryValueAxisMajorUnit, setProviderSummaryValueAxisMajorUnit] = React.useState(1);
  const [providerSummaryColors, setProviderSummaryColors] = React.useState({});

  const [providerRetentionLoading, setProviderRetentionLoading] = React.useState(true);
  const [providerDonutData, setProviderDonutData] = React.useState([]);

  const [rowData, setRowData] = React.useState([]);
  const [groupedData, setGroupedData] = React.useState({});
  const [xMax, setXMax] = React.useState(0);
  const [yMax, setYMax] = React.useState(0);
  const [attritionCategories, setAttritionCategories] = React.useState([]);
  const [attritionActiveHeadcount, setAttritionActiveHeadcount] = React.useState([]);
  const [attritionRate, setAttritionRate] = React.useState([]);
  const [attritionChartLoading, setAttritionChartLoading] = React.useState(true);
  const [attritionSeries, setAttritionSeries] = React.useState([]);
  const [providerAgeExperienceLoading, setProviderAgeExperienceLoading] = React.useState(true);
  const [providerAgeExperienceData, setProviderAgeExperienceData] = React.useState([]);
  const [providerAgeExperienceXCategories, setProviderAgeExperienceXCategories] = React.useState([]);

  const [providerAgeExperienceYCategories, setProviderAgeExperienceYCategories] = React.useState([]);

  const [turnoverChartLoading, setTurnoverChartLoading] = React.useState(true);
  const [turnoverCategories, setTurnoverCategories] = React.useState([]);
  const [turnoverSeries, setTurnoverSeries] = React.useState([]);
  const [turnoverNoDataFound, setTurnoverNoDataFound] = React.useState(false);
  const [groupValueAxisMax, setGroupValueAxisMax] = React.useState(0);
  const [groupValueAxisMajorUnit, setGroupValueAxisMajorUnit] = React.useState(1);
  const [specialityValueAxisMax, setSpecialityValueAxisMax] = React.useState(0);
  const [specialityValueAxisMajorUnit, setSpecialityValueAxisMajorUnit] = React.useState(1);
  const [turnoverLineSeries, setTurnoverLineSeries] = React.useState([]);
  const [providerARCategories, setProviderARCategories] = React.useState([]);
  const [providerARSeries, setProviderARSeries] = React.useState([]);
  const [providerARChartLoading, setProviderARChartLoading] = React.useState(true);
  const [providerARNoDataFound, setProviderARNoDataFound] = React.useState(false);

  // Helper for filter string
  const procareGetNullInFilter = (data, filterParamName, dataType = "string", alias = "a") => {
    if (!data || data.length === 0) return "";
    const nullKeyword = "a$is_null";
    let nullFilterStr = "";
    const idList = data.map((item) => item.id).join(",");

    if (idList.includes(nullKeyword)) {
      idList.replace(new RegExp(nullKeyword, "g"), "");
      nullFilterStr = ` AND (COALESCE(${alias}.${filterParamName}, ${
        dataType === "string" ? "''" : "0"
      }) ${dataType === "string" ? "= ''" : "= 0"})`;
    }

    return ` AND (${alias}.${filterParamName} IN (${idList}))${nullFilterStr}`;
  };
  const [providerAgeExperienceDetailLoading, setProviderAgeExperienceDetailLoading] = React.useState(true);
  const [providerAgeExperienceDetailData, setProviderAgeExperienceDetailData] = React.useState([]);
  const [providerAgeExperienceDetailXCategories, setProviderAgeExperienceDetailXCategories] = React.useState([]);

  const [providerAgeExperienceDetailYCategories, setProviderAgeExperienceDetailYCategories] = React.useState([]);

  // Specialty Data
  const getSpecialtyDataList = async (specialtyData, groupData, module) => {
    try {
      setSpecialtyDataFields((prevState) => ({
        ...prevState,
        isSpecialtyDataLoading: true,
      }));

      const dataObjValue = {
        in_user_key: cookiesData.out_user_id,
        in_filter: null,
        in_user_role_filter: "> 0",
        in_sort_number: 11,
        in_sort_order: "ASC",
        in_group_by: "a.specialty_mstr_key",
        in_specialty_filter: "0",
        in_title_filter: "0",
        in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
      };

      if (!searchListLoading) {
        setSearchListLoading(true);
      }

      const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);

      if (resName.length > 0) {
        const tempArray = [
          { text: "(Empty Value)", id: "0" },
          ...resName.map((item) => ({
            text: item.specialty_mstr_key === "" ? "is_null" : item.specialty_name,
            id: item.specialty_mstr_key === "" ? "" : item.specialty_mstr_key,
          })),
        ];

        setSpecialtyDataList(tempArray);

        setSpecialtyDataFields((prevState) => ({
          ...prevState,
          specialtyData: tempArray,
          isSpecialtyDataLoading: false,
          specialtyDataValue:
            module === "add-update" ? prevState.specialtyDataValue : [{ text: "Select All", id: "Select All" }],
        }));

        return tempArray;
      } else {
        setSpecialtyDataList([]);
        setSpecialtyDataFields((prevState) => ({
          ...prevState,
          isSpecialtyDataLoading: false,
          specialtyData: [],
        }));
        setGroupDataFields((prevState) => ({
          ...prevState,
          isGroupDataLoading: false,
        }));

        return false;
      }
    } catch (error) {
      setSpecialtyDataFields((prevState) => ({
        ...prevState,
        isSpecialtyDataLoading: false,
      }));
      setGroupDataFields((prevState) => ({
        ...prevState,
        isGroupDataLoading: false,
      }));

      return false;
    }
  };

  // Group Data
  const getGroupDataList = async (specialtyKeyData = null, module) => {
    setGroupDataFields((prevState) => ({
      ...prevState,
      isGroupDataLoading: true,
    }));

    const checkIsSelectAll = specialtyKeyData?.find((x) => x.id === "Select All");
    if (checkIsSelectAll) specialtyKeyData = null;

    const specialtyKey =
      specialtyKeyData === null
        ? "0"
        : specialtyKeyData.length === 1 && specialtyKeyData[0].id === "0"
          ? " AND ( IFNULL(b.specialty_mstr_key, 0) = 0 ) "
          : procareGetNullInFilter(
              specialtyKeyData.filter((x) => x.id !== "0"),
              "specialty_mstr_key",
              "number",
              "b"
            );

    const specialtyFilter =
      specialtyKeyData && specialtyKeyData.some((x) => x.id === "0") && specialtyKeyData.length > 1
        ? `${specialtyKey} OR ( IFNULL(b.specialty_mstr_key, 0) = 0 )`
        : specialtyKey;

    const dataObjValue = {
      in_user_key: cookiesData.out_user_id,
      in_filter: null,
      in_user_role_filter: "> 0",
      in_sort_number: 10,
      in_sort_order: "ASC",
      in_group_by: "a.org_title_key",
      in_specialty_filter: specialtyFilter || "0",
      in_title_filter: "0",
      in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
    };

    try {
      const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);
      const tempArray =
        resName.length > 0
          ? [
              { text: "(Empty Value)", id: "0" },
              ...resName.map((item) => ({
                text: item.org_title_key === "" ? "is_null" : item.title_name,
                id: item.org_title_key === "" ? "" : item.org_title_key,
              })),
            ]
          : [{ text: "(Empty Value)", id: "0" }];

      setGroupDataList(tempArray);

      setGroupDataFields((prevState) => ({
        ...prevState,
        groupData: tempArray,
        isGroupDataLoading: false,
        ...(module !== "add-update" && {
          groupDataValue: [{ text: "Select All", id: "Select All" }],
        }),
      }));
    } catch (error) {
      setGroupDataList([{ text: "(Empty Value)", id: "0" }]);
      setGroupDataFields((prevState) => ({
        ...prevState,
        isGroupDataLoading: false,
        groupData: [],
      }));
    }
  };

  // Position Data
  const getPostionDataList = async (specialtyKeyData = null, groupKeyData = null, module) => {
    setPositionDataFields((prevState) => ({
      ...prevState,
      isPositionDataLoading: true,
    }));

    if (specialtyKeyData?.some((x) => x.id === "Select All")) specialtyKeyData = null;
    if (groupKeyData?.some((x) => x.id === "Select All")) groupKeyData = null;

    const specialtyKey =
      specialtyKeyData === null
        ? "0"
        : specialtyKeyData.length === 1 && specialtyKeyData[0].id === "0"
          ? " AND ( IFNULL(b.specialty_mstr_key, 0) = 0 ) "
          : procareGetNullInFilter(
              specialtyKeyData.filter((x) => x.id !== "0"),
              "specialty_mstr_key",
              "number",
              "b"
            );

    const groupKey =
      groupKeyData === null
        ? "0"
        : groupKeyData.length === 1 && groupKeyData[0].id === "0"
          ? " AND ( IFNULL(b.org_title_key, 0) = 0 ) "
          : procareGetNullInFilter(groupKeyData, "org_title_key", "number", "b");

    const dataObjValue = {
      in_user_key: cookiesData.out_user_id,
      in_filter: null,
      in_user_role_filter: "> 0",
      in_sort_number: 12,
      in_sort_order: "ASC",
      in_group_by: "a.org_position_key",
      in_specialty_filter: specialtyKey || "0",
      in_title_filter: groupKey || "0",
      in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
    };

    try {
      const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);

      const tempArray = [
        ...resName.map((item) => ({
          text: item.org_position_key === "" ? "(Empty Value)" : item.position_name,
          id: item.org_position_key === "" ? "" : item.org_position_key,
        })),
      ];

      setPositionDataList(tempArray);

      let dataValue = positionDataFields.positionDataValue.map((item) => {
        const matchingObject = tempArray.find((tempItem) => tempItem.id === item.id);
        return matchingObject ? { ...item, ...matchingObject } : item;
      });

      setPositionDataFields((prevState) => ({
        ...prevState,
        ...(module === "add-update"
          ? {
              positionDataValue: dataValue,
            }
          : tempArray.length && {
              positionDataValue: [{ text: "Select All", id: "Select All" }],
            }),
        positionData: tempArray,
        isPositionDataLoading: false,
      }));
    } catch (error) {
      setPositionDataFields((prevState) => ({
        ...prevState,
        isPositionDataLoading: false,
        positionData: [],
        positionDataValue: [{ text: "Select All", id: "Select All" }],
      }));
    }
  };

  // Employee Data
  const getEmployeeDataList = async (specialtyKeyData = null, groupKeyData = null, module) => {
    setEmployeeDataFields((prevState) => ({
      ...prevState,
      isEmployeeDataLoading: true,
    }));

    if (specialtyKeyData?.some((x) => x.id === "Select All")) specialtyKeyData = null;
    if (groupKeyData?.some((x) => x.id === "Select All")) groupKeyData = null;

    const specialtyKey =
      specialtyKeyData === null
        ? "0"
        : specialtyKeyData.length === 1 && specialtyKeyData[0].id === "0"
          ? " AND ( IFNULL(b.specialty_mstr_key, 0) = 0 ) "
          : procareGetNullInFilter(
              specialtyKeyData.filter((x) => x.id !== "0"),
              "specialty_mstr_key",
              "number",
              "b"
            );

    const specialtyFilter =
      specialtyKeyData?.some((x) => x.id === "0") && specialtyKeyData?.length > 1
        ? `${specialtyKey} OR ( IFNULL(b.specialty_mstr_key, 0) = 0 )`
        : specialtyKey;

    const groupKey =
      groupKeyData === null
        ? "0"
        : groupKeyData.length === 1 && groupKeyData[0].id === "0"
          ? " AND ( IFNULL(b.org_title_key, 0) = 0 ) "
          : procareGetNullInFilter(
              groupKeyData.filter((x) => x.id !== "0"),
              "org_title_key",
              "number",
              "b"
            );

    const groupFilter =
      groupKeyData?.some((x) => x.id === "0") && groupKeyData?.length > 1
        ? `${groupKey} OR ( IFNULL(b.org_title_key, 0) = 0 )`
        : groupKey;

    const dataObjValue = {
      in_user_key: cookiesData.out_user_id,
      in_filter: null,
      in_user_role_filter: "> 0",
      in_sort_number: 8,
      in_sort_order: "ASC",
      in_group_by: "a.employee_id",
      in_specialty_filter: specialtyFilter || "0",
      in_title_filter: groupFilter || "0",
      in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
    };

    try {
      const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);

      const tempArray = [
        ...resName.map((item) => ({
          text: item.employee_id === "" ? "(Empty Value)" : item.employee_id,
          id: item.employee_id === "" ? "" : item.employee_id,
        })),
      ];

      setEmployeeDataList(tempArray);

      setEmployeeDataFields((prevState) => ({
        ...prevState,
        employeeData: tempArray,
        isEmployeeDataLoading: false,
        ...(module !== "add-update" &&
          tempArray.length && {
            employeeDataValue: [{ text: "Select All", id: "Select All" }],
          }),
      }));
    } catch (error) {
      setEmployeeDataFields((prevState) => ({
        ...prevState,
        isEmployeeDataLoading: false,
        employeeData: [],
        employeeDataValue: [{ text: "Select All", id: "Select All" }],
      }));
    }
  };

  // NPI Data
  const getNpiDataList = async (specialtyKeyData = null, groupKeyData = null, module) => {
    setNpiDataFields((prevState) => ({
      ...prevState,
      isNpiDataLoading: true,
    }));

    if (specialtyKeyData?.some((x) => x.id === "Select All")) specialtyKeyData = null;
    if (groupKeyData?.some((x) => x.id === "Select All")) groupKeyData = null;

    const specialtyKey =
      specialtyKeyData === null
        ? "0"
        : specialtyKeyData.length === 1 && specialtyKeyData[0].id === "0"
          ? " AND ( IFNULL(b.specialty_mstr_key, 0) = 0 ) "
          : procareGetNullInFilter(
              specialtyKeyData.filter((x) => x.id !== "0"),
              "specialty_mstr_key",
              "number",
              "b"
            );

    const specialtyFilter =
      specialtyKeyData?.some((x) => x.id === "0") && specialtyKeyData.length > 1
        ? `${specialtyKey} OR ( IFNULL(b.specialty_mstr_key, 0) = 0 )`
        : specialtyKey;

    const groupKey =
      groupKeyData === null
        ? "0"
        : groupKeyData.length === 1 && groupKeyData[0].id === "0"
          ? " AND ( IFNULL(b.org_title_key, 0) = 0 ) "
          : procareGetNullInFilter(
              groupKeyData.filter((x) => x.id !== "0"),
              "org_title_key",
              "number",
              "b"
            );

    const groupFilter =
      groupKeyData?.some((x) => x.id === "0") && groupKeyData.length > 1
        ? `${groupKey} OR ( IFNULL(b.org_title_key, 0) = 0 )`
        : groupKey;

    const dataObjValue = {
      in_user_key: cookiesData.out_user_id,
      in_filter: null,
      in_user_role_filter: "> 0",
      in_sort_number: 9,
      in_sort_order: "ASC",
      in_group_by: "a.npi",
      in_specialty_filter: specialtyFilter || "0",
      in_title_filter: groupFilter || "0",
      in_acct_encrypt_key: cookiesData.out_acct_encrypt_key,
    };

    try {
      const resName = await getProvidePostionFilter(dataObjValue, dispatch, history);

      const tempArray = [
        ...resName.map((item) => ({
          text: item.npi === "" ? "(Empty Value)" : item.npi,
          id: item.npi === "" ? "" : item.npi,
        })),
      ];

      setNpiDataList(tempArray);

      setNpiDataFields((prevState) => ({
        ...prevState,
        npiData: tempArray,
        isNpiDataLoading: false,
        ...(module !== "add-update" &&
          tempArray.length && {
            npiDataValue: [{ text: "Select All", id: "Select All" }],
          }),
      }));
    } catch (error) {
      setNpiDataFields((prevState) => ({
        ...prevState,
        isNpiDataLoading: false,
        npiData: [],
        npiDataValue: [{ text: "Select All", id: "Select All" }],
      }));
    }
  };

  const getTimePeriodData = async (listData) => {
    try {
      const res = await POSTAPI(false, GET_TIME_PERIOD_DATA, null, header, listData, dispatch);
      if (res.status) {
        if (res.data.out_parameters.out_ret_code > 0) {
          setTimePeriodData({
            ...timePeriodData,
            istimePeriodDataLoading: false,
          });
          return null;
        } else {
          let tempArray = res.data.row_result.map((item) => ({
            text: item.time_period_name + (item.time_period_label ? `(${item.time_period_label})` : ""),
            value: item.time_period_start_date + " - " + item.time_period_end_date,
          }));

          const timePeriodValue =
            tempArray.find((item) => item.text.toLowerCase().startsWith("current year")) || tempArray[0];

          setOriginalTimePeriodData(tempArray);
          setTimePeriodData({
            ...timePeriodData,
            timePeriodValue: timePeriodValue,
            timePeriodDataValue: tempArray,
            istimePeriodDataLoading: false,
          });

          return tempArray;
        }
      }
    } catch (error) {
      console.error("Error fetching time period data:", error);
      return null;
    }
  };

  const getProviderDashboardCardData = (data) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_DASHBOARD_CARD_DATA, null, header, data, dispatch).then((res) => {
        const { out_ret_code, out_total_rows } = res.data.out_parameters;
        if (out_ret_code === 0 || out_ret_code === 2) {
          setIsProviderStatusAPICalling(false);
          if (res.data.out_parameters?.out_total_rows.length > 0) {
            setProviderCardData(out_total_rows);
            resolve(out_total_rows);
          } else {
            setProviderCardData([]);
            resolve([]);
          }
        } else {
          setIsProviderStatusAPICalling(false);
        }
      });
    });
  };

  // const GetFilterQuery = (data) => {
  //   return new Promise(function (resolve, reject) {
  //     POSTAPI(
  //       false,
  //       GET_FILTER_QUERY,
  //       null,
  //       generateHeader(),
  //       data,
  //       dispatch
  //     ).then((res) => {
  //       if (
  //         res &&
  //         (res.data.out_parameters.out_ret_code === 0 ||
  //           res.data.out_parameters.out_ret_code === 2)
  //       ) {
  //         const columData = GridColumnDataMapper(
  //           res.data.out_parameters.out_column_xml
  //         );
  //         setColoumnData(columData);
  //         setData(res.data.row_result);
  //         resolve(res.data.row_result);
  //       } else {
  //         resolve([]);
  //         errStatusHandler(res, history, dispatch);
  //       }
  //     });
  //   }).catch((res) => {
  //     if (res.data.out_parameters.out_ret_code > 0) {
  //       dispatch(
  //         setNewMessage({
  //           message: res.data.out_parameters.out_error_msg,
  //           type: "Error",
  //           show: true,
  //         })
  //       );
  //       errStatusHandler(res, history, dispatch);
  //     }
  //   });
  // };

  const GetFilterQuery = (data) => {
    return new Promise(function (resolve, reject) {
      try {
        // 🔹 Static mock response
        const res = {
          out_parameters: {
            out_total_rows: 13,
            out_column_xml:
              '{"resultset":{"metadata":[{"field":[{"$":{"name":"a.grid_filter_history_key","label":"","type":"number","filterable":"0","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.filter_name","label":"FILTER NAME","type":"string","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.filter_desc","label":"FILTER DESCRIPTION","type":"string","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.is_favorite","label":"IS FAVORITE","type":"boolean","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.favorite_date","label":"FAVORITE DATE","type":"date","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.action_date","label":"ACTION DATE","type":"date","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.action","label":"ACTION","type":"string","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]},{"$":{"name":"a.filter_text","label":"FILTER TEXT","type":"string","filterable":"1","encrypted":"0"},"format":[""],"aggregate":[""],"groupHeaderTemplate":[""],"groupFooterTemplate":[""],"footerTemplate":[""]}]}]}}',
            out_ret_code: 0,
            out_error_msg: "",
          },
          row_result: [
            {
              grid_filter_history_key: 13,
              filter_name: "NPI Filter",
              filter_desc: "",
              filter_text: "AND NPI = 1003002627",
              is_favorite: 1,
              favorite_date: "2025-08-19 07:06:58",
              action_date: "2025-08-19 07:06:58",
              user_key: 43943,
              version: 2,
            },
            {
              grid_filter_history_key: 12,
              filter_name: "EMP ID Filter",
              filter_desc: "",
              filter_text: "AND employee_id = 10131",
              is_favorite: 1,
              favorite_date: "2025-08-19 07:48:15",
              action_date: "2025-08-19 07:48:15",
              user_key: 43943,
              version: 3,
            },
            {
              grid_filter_history_key: 11,
              filter_name: "Position Filter",
              filter_desc: "Position name filters",
              filter_text:
                "AND position_name IN ('Adami Angela-44512', 'Adams Anetta-44071','Acierto David John-43048')",
              is_favorite: 0,
              favorite_date: null,
              action_date: "2025-08-19 05:29:04",
              user_key: 43943,
              version: 3,
            },
            {
              grid_filter_history_key: 11,
              filter_name: "Provider ID Filter",
              filter_desc: "provider ID filters",
              filter_text: "AND provider_id IN (10001,10002, 10003)",
              is_favorite: 0,
              favorite_date: null,
              action_date: "2025-08-19 05:29:04",
              user_key: 43943,
              version: 3,
            },
          ],
        };

        // 🔹 Map column XML and set states
        const columData = GridColumnDataMapper(res.out_parameters.out_column_xml);
        setColoumnData(columData);
        setData(res.row_result);

        resolve(res.row_result);
      } catch (err) {
        reject(err);
      }
    });
  };

  const getProviderStatusAndPlanData = (data) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_STATUS_AND_PLAN_DATA, null, header, data, dispatch)
        .then((res) => {
          const { out_ret_code, out_total_rows } = res.data.out_parameters;

          if (out_ret_code === 0 || out_ret_code === 2) {
            setAPICallingState(false);
            setLoadingState(true);

            if (out_total_rows?.length > 0) {
              setProviderPlanStatusData(out_total_rows);

              const rowResult = res.data.row_result || [];

              const categoryArray = [...new Set(rowResult.map((item) => item.category_axis))];
              // Sort series names so color/legend order is consistent across charts
              const statusTypes = [...new Set(rowResult.map((item) => item.series_name.toLowerCase()))].sort();

              const colorPalette = CHART_COLOR_PALETTE;

              const statusColors = {};
              statusTypes.forEach((status, index) => {
                statusColors[status] = colorPalette[index % colorPalette.length];
              });

              const formatStatusName = (name) =>
                name
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");

              const dynamicSeries = statusTypes.map((statusKey) => ({
                name: formatStatusName(statusKey),
                data: categoryArray.map((category) => {
                  const item = rowResult.find(
                    (d) => d.category_axis === category && d.series_name.toLowerCase() === statusKey
                  );
                  return item ? item.series_data : 0;
                }),
                color: statusColors[statusKey],
                visible: 1,
              }));

              const allValues = dynamicSeries.flatMap((s) => s.data);
              const maxValue = Math.max(...allValues);
              const niceMax = Math.ceil(maxValue / 5) * 5;
              const majorUnit = niceMax > 0 ? Math.ceil(niceMax / 5) : 5;

              setValueAxisMax(niceMax);
              setValueAxisMajorUnit(majorUnit);
              setCategories(categoryArray);
              setSeries(dynamicSeries);
              setNoDataFound(false);
              setIsProviderStatusAndPlanDataLoading(false);
              resolve(rowResult);
            } else {
              setNoDataFound(true);
              setProviderPlanStatusData([]);
              setIsProviderStatusAndPlanDataLoading(false);
              resolve([]);
            }
          } else {
            setIsProviderStatusAPICalling(false);
            setNoDataFound(true);
            setLoadingState(true);
            setIsProviderStatusAndPlanDataLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error in getProviderStatusAndPlanData:", error);
          reject(error);
        });
    });
  };

  const getProviderSpeclityStatusAndPlanData = (data) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_STATUS_AND_PLAN_DATA_BY_SPECIALITY, null, header, data, dispatch)
        .then((res) => {
          const { out_ret_code, out_total_rows } = res.data.out_parameters;

          if (out_ret_code === 0 || out_ret_code === 2) {
            setspeclityAPICallingState(false);
            setspeclityLoadingState(true);

            if (out_total_rows?.length > 0) {
              setProviderspeclityPlanStatusData(out_total_rows);

              const rowResult = res.data.row_result || [];

              const categoryArray = [...new Set(rowResult.map((item) => item.category_axis))];
              const statusTypes = [
                ...new Set(
                  rowResult.filter((item) => item.series_name != null).map((item) => item.series_name.toLowerCase())
                ),
              ].sort();

              const colorPalette = CHART_COLOR_PALETTE;

              const statusColors = {};
              statusTypes.forEach((status, index) => {
                statusColors[status] = colorPalette[index % colorPalette.length];
              });

              const formatStatusName = (name) =>
                name
                  .split(" ")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ");

              const dynamicSeries = statusTypes.map((statusKey) => ({
                name: formatStatusName(statusKey),
                data: categoryArray.map((category) => {
                  const item = rowResult.find(
                    (d) =>
                      d.category_axis === category && d.series_name != null && d.series_name.toLowerCase() === statusKey
                  );
                  return item ? item.series_data : 0;
                }),
                color: statusColors[statusKey],
                visible: 1,
              }));

              const allValues = dynamicSeries.flatMap((s) => s.data);
              const maxValue = Math.max(...allValues);
              const niceMax = Math.ceil(maxValue / 5) * 5;
              const majorUnit = niceMax > 0 ? Math.ceil(niceMax / 5) : 5;

              setspeclityValueAxisMax(niceMax);
              setspeclityValueAxisMajorUnit(majorUnit);
              setspeclityCategories(categoryArray);
              setspeclitySeries(dynamicSeries);
              setisspeclityProviderStatusAndPlanDataLoading(false);
              resolve(rowResult);
            } else {
              setisspeclityProviderStatusAndPlanDataLoading(false);
              resolve([]);
            }
          } else {
            setspeclityAPICallingState(false);
            setspeclityLoadingState(true);
            setisspeclityProviderStatusAndPlanDataLoading(false);
            setspeclityNoDataFound(true);
            setProviderspeclityPlanStatusData([]);
          }
        })
        .catch((error) => {
          console.error("Error in getProviderSpeclityStatusAndPlanData:", error);
          reject(error);
        });
    });
  };
  const getPositionTypeData = (data) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_POSITION_TYPE_DATA, null, header, data, dispatch)
        .then((res) => {
          const { out_ret_code, out_total_rows } = res.data.out_parameters;
          if (out_ret_code === 0 || out_ret_code === 2) {
            setProviderPlanStatusData(out_total_rows);

            const rowResult = res.data.row_result || [];

            const categoryArray = [...new Set(rowResult.map((item) => item.category_axis))];
            const statusTypes = [...new Set(rowResult.map((item) => item.series_name.toLowerCase()))].sort();

            const colorPalette = CHART_COLOR_PALETTE;

            const statusColors = {};
            statusTypes.forEach((status, index) => {
              statusColors[status] = colorPalette[index % colorPalette.length];
            });

            const formatStatusName = (name) =>
              name
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");

            const dynamicSeries = statusTypes.map((statusKey) => ({
              name: formatStatusName(statusKey),
              data: categoryArray.map((category) => {
                const item = rowResult.find(
                  (d) => d.category_axis === category && d.series_name.toLowerCase() === statusKey
                );
                return item ? item.series_data : 0;
              }),
              color: statusColors[statusKey],
              visible: 1,
            }));

            // ✅ Donut chart data (Active only, top 10 ascending)
            const activeSeries = dynamicSeries.find((s) => s.name.toLowerCase() === "active");

            const donutChartData = categoryArray
              .map((category, idx) => {
                const actualValue = activeSeries?.data[idx] || 0;
                const isDefaultCategory = (category || "").toString().toLowerCase() === "default";
                return {
                  category,
                  value: isDefaultCategory ? 0 : actualValue,
                  originalValue: actualValue,
                  color: colorPalette[idx % colorPalette.length],
                  name: category,
                  visible: isDefaultCategory ? 0 : 1,
                };
              })
              .filter((d) => d.value > 0 || (d.category || "").toString().toLowerCase() === "default")
              .sort((a, b) => a.value - b.value);

            // ✅ Column chart scaling
            const allValues = dynamicSeries.flatMap((s) => s.data);
            const maxValue = Math.max(...allValues);
            const niceMax = Math.ceil(maxValue / 5) * 5;
            const majorUnit = niceMax > 0 ? Math.ceil(niceMax / 5) : 5;

            setProviderValueAxisMax(niceMax);
            setProviderValueAxisMajorUnit(majorUnit);
            setProviderTypeCategories(categoryArray);
            setProviderTypeSeries(dynamicSeries);

            // ✅ Store donut chart data
            setProviderDonutData(donutChartData);

            resolve(res.data.row_result);
            setIsPositionDataLoading(false);
          } else {
            setIsPositionDataLoading(false);
            resolve([]);
          }
        })
        .catch((error) => {
          setIsPositionDataLoading(false);
          reject(error);
        });
    });
  };

  const getTopProviderPositionyByGroup = (data) => {
    return new Promise((resolve, reject) => {
      POSTAPI(false, GET_SPECIALITY_GROUP_POSITION_DATA, null, header, data, dispatch)
        .then((res) => {
          const { out_ret_code, out_total_rows } = res.data.out_parameters;

          if (out_ret_code === 0 || out_ret_code === 2) {
            setAPICallingState(false);
            setLoadingState(true);

            const rowData = res.data.row_result || [];

            if (out_total_rows.length > 0 && rowData.length > 0) {
              setGroupSpecialtyPositionData(out_total_rows);

              // Collect unique names (sorted for consistent legend order)
              const serviceLines = Array.from(new Set(rowData.map((d) => d.series_name))).sort();
              const providerTypes = Array.from(new Set(rowData.map((d) => d.category_axis))).sort();

              const colorPalette = CHART_COLOR_PALETTE;
              const providerTypeColors = providerTypes.reduce((acc, type, idx) => {
                acc[type] = colorPalette[idx % colorPalette.length];
                return acc;
              }, {});
              setGroupProviderTypeColors(providerTypeColors);

              // Group data
              const groupedByProvider = providerTypes.map((providerType) => {
                const values = serviceLines.map((serviceLine) => {
                  const match = rowData.find((d) => d.category_axis === providerType && d.series_name === serviceLine);
                  return {
                    category: serviceLine,
                    value: match ? match.series_data : 0,
                  };
                });

                return {
                  name: providerType,
                  data: values,
                  color: providerTypeColors[providerType],
                  visible: 1,
                };
              });

              setGroupPositionTypeSeries(groupedByProvider);
              setGroupPositionTypeCategories(serviceLines);

              // ✅ Dynamic Y-axis calculation (always integers)
              const allValues = rowData.map((d) => d.series_data || 0);
              const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0;
              const niceMax = Math.ceil(maxValue / 5) * 5; // round to nearest multiple of 5
              const majorUnit = niceMax > 0 ? Math.ceil(niceMax / 5) : 1;

              setGroupValueAxisMax(niceMax);
              setGroupValueAxisMajorUnit(majorUnit);

              resolve(rowData);
              setIsGroupSpecialtyPositionDataLoading(false);
            } else {
              setIsGroupSpecialtyPositionDataLoading(false);
              setGroupNoDataFound(true);
              setGroupSpecialtyPositionData([]);
              resolve([]);
            }
          } else {
            setIsProviderStatusAPICalling(false);
            setGroupNoDataFound(true);
            setLoadingState(true);
            setIsGroupSpecialtyPositionDataLoading(false);
            reject("API returned error");
          }
        })
        .catch((err) => {
          setIsProviderStatusAPICalling(false);
          setLoadingState(false);
          setIsGroupSpecialtyPositionDataLoading(false);
          setGroupNoDataFound(true);
          console.error("API failed:", err);
          reject(err);
        });
    });
  };
  const getTopProviderPositionBySpecialty = (data) => {
    return new Promise((resolve, reject) => {
      POSTAPI(false, GET_SPECIALITY_GROUP_POSITION_DATA, null, header, data, dispatch)
        .then((res) => {
          const { out_ret_code, out_total_rows } = res.data.out_parameters;

          if (out_ret_code === 0 || out_ret_code === 2) {
            setAPICallingState(false);
            setLoadingState(true);

            const rowData = res.data.row_result || [];

            if (out_total_rows.length > 0 && rowData.length > 0) {
              setSpecialtyPositionData(out_total_rows);

              // Collect unique names (sorted for consistent legend order)
              const serviceLines = Array.from(new Set(rowData.map((d) => d.series_name))).sort();
              const providerTypes = Array.from(new Set(rowData.map((d) => d.category_axis))).sort();

              const colorPalette = CHART_COLOR_PALETTE;
              const providerTypeColors = providerTypes.reduce((acc, type, idx) => {
                acc[type] = colorPalette[idx % colorPalette.length];
                return acc;
              }, {});
              setSpecialtyProviderTypeColors(providerTypeColors);

              // Group data
              const groupedByProvider = providerTypes.map((providerType) => {
                const values = serviceLines.map((serviceLine) => {
                  const match = rowData.find((d) => d.category_axis === providerType && d.series_name === serviceLine);
                  return {
                    category: serviceLine,
                    value: match ? match.series_data : 0,
                  };
                });

                return {
                  name: providerType,
                  data: values,
                  color: providerTypeColors[providerType],
                  visible: 1,
                };
              });

              setSpecialtyPositionTypeSeries(groupedByProvider);
              setSpecialtyPositionTypeCategories(serviceLines);

              // ✅ Dynamic Y-axis calculation (always integers)
              const allValues = rowData.map((d) => d.series_data || 0);
              const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0;
              const niceMax = Math.ceil(maxValue / 5) * 5; // round to nearest multiple of 5
              const majorUnit = niceMax > 0 ? Math.ceil(niceMax / 5) : 1;

              setSpecialityValueAxisMax(niceMax);
              setSpecialityValueAxisMajorUnit(majorUnit);

              resolve(rowData);
              setIsSpecialtyPositionDataLoading(false);
            } else {
              setIsSpecialtyPositionDataLoading(false);
              setSpecialtyNoDataFound(true);
              setSpecialtyPositionData([]);
              resolve([]);
            }
          } else {
            setIsProviderStatusAPICalling(false);
            setSpecialtyNoDataFound(true);
            setLoadingState(true);
            setIsSpecialtyPositionDataLoading(false);
            reject("API returned error");
          }
        })
        .catch((err) => {
          setIsProviderStatusAPICalling(false);
          setLoadingState(false);
          setIsSpecialtyPositionDataLoading(false);
          setSpecialtyNoDataFound(true);
          console.error("API failed:", err);
          reject(err);
        });
    });
  };

  const GetProviderChartStatusSummary = (data) => {
    setProviderSummaryLoading(true);

    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_CHART_STATUS_SUMMARY, null, generateHeader(), data, dispatch)
        .then((res) => {
          if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 2)) {
            const rowData = res.data.row_result || [];

            if (rowData.length > 0) {
              const categories = [...new Set(rowData.map((item) => item.category_axis))];

              // ✅ Group by series_name

              const colorPalette = CHART_COLOR_PALETTE;
              // Group by series_name (sorted for consistent legend/color order)
              const seriesNames = [...new Set(rowData.map((item) => item.series_name))].sort();

              // Assign colors
              const seriesColors = seriesNames.reduce((acc, name, idx) => {
                acc[name] = colorPalette[idx % colorPalette.length];
                return acc;
              }, {});

              setProviderSummaryColors(seriesColors);

              // Build chart series
              const series = seriesNames.map((name) => ({
                name,
                type: "line",
                color: seriesColors[name], // <-- attach color here
                data: categories.map((cat) => {
                  const found = rowData.find((item) => item.category_axis === cat && item.series_name === name);
                  return found ? Math.round(Number(found.series_data)) : 0;
                }),
                visible: 1,
              }));

              // ✅ Calculate nice max & major unit (no decimals)
              const allValues = rowData.map((d) => Number(d.series_data) || 0);
              const maxValue = allValues.length > 0 ? Math.max(...allValues) : 0;
              const niceMax = Math.ceil(maxValue / 5) * 5;
              const majorUnit = niceMax > 0 ? Math.ceil(niceMax / 5) : 1;

              setProviderSummaryCategories(categories);
              setProviderSummaryData(series);
              setProviderSummaryValueAxisMax(niceMax);
              setProviderSummaryValueAxisMajorUnit(majorUnit);
            } else {
              setProviderSummaryCategories([]);
              setProviderSummaryData([]);
              setProviderSummaryValueAxisMax(0);
              setProviderSummaryValueAxisMajorUnit(1);
            }

            resolve(rowData);
          } else {
            setProviderSummaryCategories([]);
            setProviderSummaryData([]);
            setProviderSummaryValueAxisMax(0);
            setProviderSummaryValueAxisMajorUnit(1);
            errStatusHandler(res, history, dispatch);
            resolve([]);
          }
        })
        .catch((res) => {
          if (res?.data?.out_parameters?.out_ret_code > 0) {
            dispatch(
              setNewMessage({
                message: res.data.out_parameters.out_error_msg,
                type: "Error",
                show: true,
              })
            );
            errStatusHandler(res, history, dispatch);
          }
          setProviderSummaryCategories([]);
          setProviderSummaryData([]);
          setProviderSummaryValueAxisMax(0);
          setProviderSummaryValueAxisMajorUnit(1);
          resolve([]);
        })
        .finally(() => {
          setProviderSummaryLoading(false);
        });
    });
  };
  const GetProviderBaseTableData = (data) => {
    // setProviderSummaryLoading(true);

    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_BASE_TABLE, null, generateHeader(), data, dispatch)
        .then((res) => {
          if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 2)) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((res) => {
          if (res?.data?.out_parameters?.out_ret_code > 0) {
            dispatch(
              setNewMessage({
                message: res.data.out_parameters.out_error_msg,
                type: "Error",
                show: true,
              })
            );
            errStatusHandler(res, history, dispatch);
          }
        })
        .finally(() => {
          resolve(true);
        });
    });
  };
  // API call + transformation
  const getProviderChartRetention = (data) => {
    setProviderRetentionLoading(true);

    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_CHART_RETENTION, null, generateHeader(), data, dispatch)
        .then((res) => {
          if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 1)) {
            const rowData = res.data.row_result || [];

            setRowData(rowData);

            if (rowData.length > 0) {
              // Transform data
              const transformed = rowData.map((item, idx) => {
                const y = parseFloat(item.yValue?.replace("%", "")) || 0;
                const x = item.xValue !== null && !isNaN(item.xValue) ? Number(item.xValue) : idx + 1; // fallback index

                // Bubble size proportional to % but scaled
                // const size = (y / 100) * 30; // max 30px at 100%

                return {
                  category: item.category,
                  x,
                  y,
                  yLabel: `${y}%`,
                  zLabel: item.zValue,
                  size: item.zValue,
                };
              });

              // Assign colors + group by category, using global palette for consistency
              const colorPalette = CHART_COLOR_PALETTE;
              const grouped = Object.values(
                transformed.reduce((acc, curr) => {
                  if (!acc[curr.category]) {
                    acc[curr.category] = {
                      name: curr.category,
                      data: [],
                      color: colorPalette[Object.keys(acc).length % colorPalette.length],
                      visible: true,
                    };
                  }
                  acc[curr.category].data.push(curr);
                  return acc;
                }, {})
              );

              setGroupedData(grouped);

              // Dynamic Y axis
              setYMax(100); // always percentage
              setXMax(Math.max(...transformed.map((d) => d.x), 0));
            } else {
              setGroupedData([]);
              setXMax(0);
              setYMax(0);
            }

            resolve(rowData);
          } else {
            setGroupedData([]);
            setXMax(0);
            setYMax(0);
            errStatusHandler(res, history, dispatch);
            resolve([]);
          }
        })
        .catch((res) => {
          if (res?.data?.out_parameters?.out_ret_code > 0) {
            dispatch(
              setNewMessage({
                message: res.data.out_parameters.out_error_msg,
                type: "Error",
                show: true,
              })
            );
            errStatusHandler(res, history, dispatch);
          }
          setGroupedData([]);
          setXMax(0);
          setYMax(0);
          resolve([]);
        })
        .finally(() => {
          setProviderRetentionLoading(false);
        });
    });
  };

  const GetLandingDashboardData = (data) => {
    // setProviderSummaryLoading(true);

    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_LANDING_DASHBOARD_DATA, null, generateHeader(), data, dispatch)
        .then((res) => {
          if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 2)) {
            const rowData = res.data.row_result || [];
            resolve(rowData);
          } else {
            resolve(false);
          }
        })
        .catch((res) => {
          if (res?.data?.out_parameters?.out_ret_code > 0) {
            dispatch(
              setNewMessage({
                message: res.data.out_parameters.out_error_msg,
                type: "Error",
                show: true,
              })
            );
            errStatusHandler(res, history, dispatch);
          }
        })
        .finally(() => {
          resolve(true);
        });
    });
  };

  const getProviderChartAttritionData = (data) => {
    setAttritionChartLoading(true);

    return new Promise((resolve, reject) => {
      POSTAPI(false, GET_PROVIDER_CHART_ATTRITION, null, generateHeader(), data, dispatch)
        .then((res) => {
          const { out_ret_code } = res?.data?.out_parameters || {};
          const rows = res?.data?.row_result || [];

          if (res && (out_ret_code === 0 || out_ret_code === 1)) {
            const categoryArray = rows.map((item) => item.Quarter);
            const activeHeadcountData = rows.map((item) => item.ActiveHeadcount);
            const attritionRateData = rows.map((item) => item["Attrition Rate%"]);

            const dynamicSeries = [
              {
                name: "Active Headcount",
                type: "line",
                data: activeHeadcountData,
                color: PROCARE_COLORS.primaryBlue,
                visible: 1,
              },
              {
                name: "Attrition Rate%",
                type: "area",
                data: attritionRateData,
                color: PROCARE_COLORS.primaryGreen,
                style: "smooth",
                visible: 1,
              },
            ];

            setAttritionCategories(categoryArray);
            setAttritionSeries(dynamicSeries);
            setNoDataFound(false);
            resolve();
          } else {
            reject("Unexpected response format");
          }
        })
        .catch((res) => {
          errStatusHandler(res, history, dispatch);
          reject(res);
        })
        .finally(() => setAttritionChartLoading(false));
    });
  };
  function makeDataObjects(rows, cols) {
    const data = [];

    for (let rowIndex = 0; rowIndex < rows; rowIndex++) {
      for (let colIndex = 0; colIndex < cols; colIndex++) {
        data.push({
          x: `A${rowIndex + 1}`, // previously "a"
          y: `B${colIndex + 1}`, // previously "b"
          value: cols + rowIndex * colIndex, // same logic for numeric value
        });
      }
    }

    return data;
  }

  const GetProviderChartAgeVsExperience = (data) => {
    setProviderAgeExperienceLoading(true);

    return new Promise((resolve) => {
      POSTAPI(false, GET_PROVIDER_CHART_YOE_COMBINE, null, generateHeader(), data, dispatch)
        .then((res) => {
          const retCode = res?.data?.out_parameters?.out_ret_code;
          const rowData = res?.data?.row_result || [];

          if (res && (retCode === 0 || retCode === 2)) {
            if (rowData.length > 0) {
              // ---------------------------
              // 1. Group data: Reg vs Age -> Spe vs Hos
              // ---------------------------
              const groupByParent = (data) => {
                const regAge = data.filter((i) => i.chart_type === "Reg vs Age");
                const speHos = data.filter((i) => i.chart_type === "Spe vs Hos");

                // Build lookup by region + age_no
                const speLookup = speHos.reduce((acc, item) => {
                  const key = `${item.region}_${item.age_no}`;
                  if (!acc[key]) acc[key] = [];
                  acc[key].push(item);
                  return acc;
                }, {});

                // Attach spe_data
                return regAge.map((parent) => {
                  const key = `${parent.region}_${parent.age_no}`;
                  return {
                    ...parent,
                    spe_data: speLookup[key] || [],
                  };
                });
              };

              const finalGroupedData = groupByParent(rowData);

              // ---------------------------
              // 2. Build heatmap-ready array
              // ---------------------------
              const xCategories = [...new Set(finalGroupedData.map((item) => item.category_axis_x))].map((value) => ({
                value,
                isregionClick: true,
              }));

              const yCategories = [...new Set(finalGroupedData.map((item) => item.category_axis_y))].map((value) => ({
                value,
                isregionClick: true,
              }));

              const xMap = Object.fromEntries(xCategories.map((c, i) => [c.value, i]));
              const yMap = Object.fromEntries(yCategories.map((c, i) => [c.value, i]));

              const maxValue = Math.max(...finalGroupedData.map((item) => Number(item.series_data) || 0)) || 1;

              const completeHeatmapData = [];

              yCategories.forEach((y) => {
                xCategories.forEach((x) => {
                  const found = finalGroupedData.find(
                    (item) => item.category_axis_x === x.value && item.category_axis_y === y.value
                  );

                  const value = found ? Number(found.series_data) : 0;
                  completeHeatmapData.push({
                    xNumeric: xMap[x.value],
                    yNumeric: yMap[y.value],
                    categoryX: x.value,
                    categoryY: y.value,
                    value,
                    valueLabel: value > 0 ? `${value}%` : "0",
                    color: getBlueGradient(value, maxValue),
                    in_age_num: found ? found.age_no : null,
                    isregionClick: true,
                    spe_data: found ? found.spe_data : [],
                    provider_count: found ? found.provider_count : 0,
                  });
                });
              });

              // ---------------------------
              // 3. Update State
              // ---------------------------
              setProviderAgeExperienceData(completeHeatmapData);
              setProviderAgeExperienceXCategories(xCategories);
              setProviderAgeExperienceYCategories(yCategories);

              resolve(finalGroupedData);
              return;
            }

            // ---------------------------
            // No data
            // ---------------------------
            setProviderAgeExperienceData([]);
            setProviderAgeExperienceXCategories([]);
            setProviderAgeExperienceYCategories([]);
            resolve([]);
          } else {
            errStatusHandler(res, history, dispatch);
            setProviderAgeExperienceData([]);
            setProviderAgeExperienceXCategories([]);
            setProviderAgeExperienceYCategories([]);
            resolve([]);
          }
        })
        .catch((res) => {
          if (res?.data?.out_parameters?.out_ret_code > 0) {
            dispatch(
              setNewMessage({
                message: res.data.out_parameters.out_error_msg,
                type: "Error",
                show: true,
              })
            );
            errStatusHandler(res, history, dispatch);
          }
          setProviderAgeExperienceData([]);
          setProviderAgeExperienceXCategories([]);
          setProviderAgeExperienceYCategories([]);
          resolve([]);
        })
        .finally(() => {
          setProviderAgeExperienceLoading(false);
        });
    });
  };

  const getBlueGradient = (value, maxValue) => {
    const ratio = Math.min(value / maxValue, 1); // normalize 0 → 1
    const startColor = { r: 227, g: 242, b: 253 }; // very light blue (#E3F2FD)
    const endColor = { r: 13, g: 71, b: 161 }; // dark blue (#0D47A1)

    const r = Math.round(startColor.r + (endColor.r - startColor.r) * ratio);
    const g = Math.round(startColor.g + (endColor.g - startColor.g) * ratio);
    const b = Math.round(startColor.b + (endColor.b - startColor.b) * ratio);

    return `rgb(${r}, ${g}, ${b})`;
  };

  const getProviderChartTurnoverData = (data) => {
    setTurnoverChartLoading(true);
    setTurnoverNoDataFound(false);

    return new Promise((resolve) => {
      POSTAPI(false, GET_PROVIDER_TURNOVER_CHART, null, generateHeader(), data, dispatch)
        .then((res) => {
          const outParams = res?.data?.out_parameters || {};
          const rowData = res?.data?.row_result || [];

          if (rowData.length > 0 && (outParams.out_ret_code === 0 || outParams.out_ret_code === 2)) {
            // Get unique ordered categories
            const categories = [...new Set(rowData.map((r) => r.category_axis))];

            const seriesMap = {};
            rowData.forEach((r) => {
              if (!seriesMap[r.series_name]) seriesMap[r.series_name] = {};

              seriesMap[r.series_name][r.category_axis] = {
                value: r.series_data,
                provider_count: r.provider_count,
              };
            });

            // All series except turnover rate
            const areaSeriesNames = Object.keys(seriesMap).filter((name) => name !== "Turnover Rate (%)");

            let colorIndex = 0;

            // Build area series
            // AREA SERIES
            const areaSeries = areaSeriesNames.map((name) => ({
              type: "area",
              name,
              data: categories.map((cat) => ({
                value: seriesMap[name][cat]?.value ?? 0,
                provider_count: seriesMap[name][cat]?.provider_count ?? 0,
              })),
              color: CHART_COLOR_PALETTE[colorIndex++ % CHART_COLOR_PALETTE.length],
              axis: "leftAxis",
              visible: true,
            }));

            // TURNOVER RATE LINE SERIES
            const lineSeries = [
              {
                type: "line",
                name: "Turnover Rate (%)",
                data: categories.map((cat) => ({
                  value: seriesMap["Turnover Rate (%)"]?.[cat]?.value ?? 0,
                  provider_count: seriesMap["Turnover Rate (%)"]?.[cat]?.provider_count ?? 0,
                })),
                color: "#000000",
                axis: "rightAxis",
                visible: true,
              },
            ];

            setTurnoverCategories(categories);

            setTurnoverSeries([...areaSeries, ...lineSeries]);

            resolve(rowData);
          } else {
            errStatusHandler(res, history, dispatch);
            setTurnoverCategories([]);
            setTurnoverSeries([]);
            setTurnoverNoDataFound(true);
            resolve([]);
          }
        })
        .catch(() => {
          setTurnoverCategories([]);
          setTurnoverSeries([]);
          setTurnoverNoDataFound(true);
          resolve([]);
        })
        .finally(() => setTurnoverChartLoading(false));
    });
  };

  const updateLayout = (bodyData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, UPDATE_DASHBOARD_CHART_LAYOUT, null, header, bodyData, dispatch).then((res) => {
        if (res && res.data.out_parameters.out_ret_code === 0) {
          resolve(true);
        } else {
          dispatch(
            setNewMessage({
              message: res?.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve([]);
          errStatusHandler(res, history, dispatch);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };
  const GetProviderChartARData = (data) => {
    setProviderARChartLoading(true);
    setProviderARNoDataFound(false);

    return new Promise((resolve) => {
      POSTAPI(false, GET_PROVIDER_CHART_AR, null, generateHeader(), data, dispatch)
        .then((res) => {
          const rowData = res?.data?.row_result || [];
          const outParams = res?.data?.out_parameters || {};

          if (rowData.length > 0 && outParams.out_ret_code !== 1) {
            const categories = rowData.map((item) => item.group_period_name);

            const mapProviderCountItem = (item, valueKey) => ({
              value: Number(item[valueKey]) || 0,
              contracted: Number(item.contracted_providers) || 0,
              saasUsers: Number(item.saas_users) || 0,
              mobileUsers: Number(item.mobile_users) || 0,
              totalUsers: Number(item.total_users) || 0,
              additional: Number(item.additional_providers) || 0,
            });

            const series = [
              {
                type: "line",
                name: "Contracted Providers",
                data: rowData.map((item) => mapProviderCountItem(item, "contracted_providers")),
                color: CHART_COLOR_PALETTE[0],
                visible: true,
              },
              {
                type: "column",
                name: "SaaS Users",
                data: rowData.map((item) => mapProviderCountItem(item, "saas_users")),
                color: CHART_COLOR_PALETTE[1],
                visible: true,
              },
              {
                type: "column",
                name: "Mobile Users",
                data: rowData.map((item) => mapProviderCountItem(item, "mobile_users")),
                color: CHART_COLOR_PALETTE[2],
                visible: true,
              },
              {
                type: "column",
                name: "Total Users",
                data: rowData.map((item) => mapProviderCountItem(item, "total_users")),
                color: CHART_COLOR_PALETTE[3],
                visible: true,
              },
              {
                type: "column",
                name: "Additional Providers",
                data: rowData.map((item) => mapProviderCountItem(item, "additional_providers")),
                color: CHART_COLOR_PALETTE[4],
                visible: true,
              },
            ];

            setProviderARCategories(categories);
            setProviderARSeries(series);

            resolve(rowData);
          } else if (outParams.out_ret_code === 1) {
            errStatusHandler(res, history, dispatch);
            setProviderARCategories([]);
            setProviderARSeries([]);
            setProviderARNoDataFound(true);
            resolve([]);
          } else {
            setProviderARCategories([]);
            setProviderARSeries([]);
            setProviderARNoDataFound(true);
            resolve([]);
          }
        })
        .catch((err) => {
          console.error("Provider AR Chart API Error:", err);
          setProviderARCategories([]);
          setProviderARSeries([]);
          setProviderARNoDataFound(true);
          resolve([]);
        })
        .finally(() => setProviderARChartLoading(false));
    });
  };

  const groupByParent = (data) => {
    const regAge = data.filter((item) => item.chart_type === "Reg vs Age");
    const speHos = data.filter((item) => item.chart_type === "Spe vs Hos");

    // Build lookup by region + age_no
    const speLookup = speHos.reduce((acc, item) => {
      const key = `${item.region}_${item.age_no}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});

    // Attach matching spe_data
    return regAge.map((parent) => {
      const key = `${parent.region}_${parent.age_no}`;
      return {
        ...parent,
        spe_data: speLookup[key] || [],
      };
    });
  };

  return [
    {
      specialtyDataList,
      specialtyDataFields,
      setSpecialtyDataFields,
      groupDataFields,
      groupDataList,
      setGroupDataFields,
      positionDataFields,
      positionDataList,
      setPositionDataFields,
      employeeDataFields,
      employeeDataList,
      setEmployeeDataFields,
      npiDataFields,
      npiDataList,
      setNpiDataFields,
      searchListLoading,
      timePeriodData,
      setTimePeriodData,
      originalTimePeriodData,
      providerCardData,
      setProviderCardData,
      initialLoading,
      setLoadingState,
      setAPICallingState,
      isAPICalling,
      data,
      coloumnData,
      categories,
      series,
      providerTypeSeries,
      providerTypeCategories,
      providerTypeColors,
      positionTypeCategories,
      isPositionDataLoading,
      isProviderStatusAndPlanDataLoading,
      isSpecialtyPositionDataLoading,
      setIsProviderStatusAndPlanDataLoading,
      setIsSpecialtyPositionDataLoading,
      setIsPositionDataLoading,
      valueAxisMax,
      valueAxisMajorUnit,
      groupSpecialtyPositionData,
      groupPositionTypeSeries,
      groupPositionTypeCategories,
      groupProviderTypeColors,
      isGroupSpecialtyPositionDataLoading,
      groupNoDataFound,
      specialtyPositionTypeSeries,
      specialtyPositionTypeCategories,
      specialtyProviderTypeColors,
      specialtyNoDataFound,
      speclityCategories,
      setspeclityCategories,
      speclitySeries,
      setspeclitySeries,
      speclityValueAxisMax,
      setspeclityValueAxisMax,
      speclityValueAxisMajorUnit,
      setspeclityValueAxisMajorUnit,
      isspeclityProviderStatusAndPlanDataLoading,
      setisspeclityProviderStatusAndPlanDataLoading,
      speclityAPICallingState,
      setspeclityAPICallingState,
      speclityLoadingState,
      setspeclityLoadingState,
      speclityNoDataFound,
      setspeclityNoDataFound,
      ProviderspeclityPlanStatusData,
      setProviderspeclityPlanStatusData,
      providerValueAxisMax,
      providerValueAxisMajorUnit,
      setProviderTypeSeries,
      setSeries,
      setIsGroupSpecialtyPositionDataLoading,
      groupValueAxisMax,
      groupValueAxisMajorUnit,
      specialityValueAxisMax,
      specialityValueAxisMajorUnit,
      setGroupPositionTypeSeries,
      setSpecialtyPositionTypeSeries,
      providerSummaryData,
      providerSummaryCategories,
      providerSummaryLoading,
      providerSummaryValueAxisMax,
      providerSummaryValueAxisMajorUnit,
      providerSummaryColors,
      setProviderSummaryData,
      providerRetentionLoading,
      rowData,
      groupedData,
      xMax,
      yMax,
      setGroupedData,
      providerDonutData,
      setProviderDonutData,
      setIsProviderStatusAndPlanDataLoading,
      setisspeclityProviderStatusAndPlanDataLoading,
      setProviderSummaryLoading,
      setProviderRetentionLoading,
      setAttritionChartLoading,
      attritionChartLoading,
      attritionCategories,
      setAttritionCategories,
      attritionActiveHeadcount,
      setAttritionActiveHeadcount,
      attritionRate,
      setAttritionRate,
      setAttritionSeries,
      attritionSeries,
      providerAgeExperienceData,
      providerAgeExperienceXCategories,
      providerAgeExperienceYCategories,
      providerAgeExperienceLoading,
      setProviderAgeExperienceLoading,
      setProviderAgeExperienceData,
      setProviderAgeExperienceXCategories,
      setProviderAgeExperienceYCategories,
      turnoverChartLoading,
      setTurnoverChartLoading,
      turnoverCategories,
      setTurnoverCategories,
      turnoverSeries,
      setTurnoverSeries,
      turnoverNoDataFound,
      providerAgeExperienceDetailData,
      providerAgeExperienceDetailXCategories,
      providerAgeExperienceDetailYCategories,
      providerAgeExperienceDetailLoading,
      setProviderAgeExperienceDetailLoading,
      setProviderAgeExperienceDetailData,
      setProviderAgeExperienceDetailXCategories,
      setProviderAgeExperienceDetailYCategories,
      providerARCategories,
      providerARSeries,
      providerARChartLoading,
      providerARNoDataFound,
      setProviderARCategories,
      setProviderARSeries,
      setProviderARChartLoading,
      setProviderARNoDataFound,
    },
    {
      getSpecialtyDataList,
      getGroupDataList,
      getPostionDataList,
      getEmployeeDataList,
      getNpiDataList,
      getTimePeriodData,
      getProviderDashboardCardData,
      GetFilterQuery,
      getProviderStatusAndPlanData,
      getPositionTypeData,
      getTopProviderPositionyByGroup,
      getTopProviderPositionBySpecialty,
      getProviderSpeclityStatusAndPlanData,
      GetProviderChartStatusSummary,
      GetProviderBaseTableData,
      getProviderChartRetention,
      GetLandingDashboardData,
      getProviderChartAttritionData,
      GetProviderChartAgeVsExperience,
      getProviderChartTurnoverData,
      updateLayout,
      GetProviderChartARData,
    },
  ];
}
